import React from "react";
import { Briefcase } from "lucide-react";
import SettingsListPanel from "./SettingsListPanel";

const JobTitleManagement = () => (
  <SettingsListPanel
    config={{
      title: "Job Title Management",
      subtitle: "Manage employee positions and designations",
      icon: Briefcase,
      endpoint: "/api/settings/job-titles",
      itemLabel: "Job Title",
      columnLabel: "Job Title",
      placeholder: "Enter job title...",
    }}
  />
);

export default JobTitleManagement;
